var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1124,
    height: 518,
    viewBox: "0 0 1124 518",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1012.95 388.685C1009.98 364.103 937.313 359.796 934.424 391.55C904.618 346.977 797.716 343.285 773.384 378.09C768.128 362.86 736.236 358.719 721.927 371.251C724.132 349.222 695.743 337.726 665.287 336.234C644.005 335.195 625.088 327.627 614.165 316.462C594.286 296.145 569.191 265.533 569.191 215.443L562 208L554.809 215.443C554.809 265.533 529.714 296.145 509.835 316.462C498.912 327.627 479.993 335.195 458.713 336.234C428.257 337.726 399.867 349.222 402.073 371.251C387.767 358.719 355.872 362.86 350.616 378.09C326.284 343.285 219.382 346.977 189.576 391.55C186.687 359.796 114.021 364.103 111.047 388.685C101.753 350.892 62.6945 323.61 0 351.894V518H1124V351.894C1061.31 323.61 1022.25 350.892 1012.95 388.685Z",
    fill: "#F2F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.422 158.927H540.624L539.404 163.333H582.524L581.422 158.927Z",
    fill: "#787878"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.404 163.333L536.182 174.962H585.431L582.524 163.333H539.404Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.42 178.622H533.192C532.186 178.622 531.362 177.798 531.362 176.792C531.362 175.785 532.186 174.962 533.192 174.962H588.42C589.427 174.962 590.25 175.785 590.25 176.792C590.25 177.798 589.427 178.622 588.42 178.622Z",
    fill: "#787878"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M535.147 178.622C529.489 193.616 534.784 211.274 538.137 215.732L541.318 211.103C541.318 220.361 552.521 236.305 560.806 244.362V178.622H535.147Z",
    fill: "#FFA300"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.465 178.622C592.123 193.616 586.828 211.274 583.476 215.732L580.294 211.103C580.294 220.361 569.092 236.305 560.806 244.362V178.622H586.465Z",
    fill: "#f1494a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.515 178.622C540.923 188.142 544.285 199.353 546.413 202.183L548.433 199.244C548.433 205.122 555.546 215.245 560.806 220.361V178.622H544.515Z",
    fill: "#F7CE85"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.097 178.622C580.69 188.142 577.327 199.353 575.2 202.183L573.179 199.244C573.179 205.122 566.067 215.245 560.806 220.361V178.622H577.097Z",
    fill: "#FF5859"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.458 23.5361H560.8V159.024H590.571C595.292 159.024 599.119 155.197 599.119 150.476V68.1001C599.119 52.2161 594.362 36.6951 585.46 23.5391L585.458 23.5361Z",
    fill: "#CBCBCB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.145 23.5361C527.24 36.6941 522.48 52.2181 522.48 68.1061V150.476C522.48 155.197 526.307 159.024 531.028 159.024H560.8V23.5361H536.145Z",
    fill: "#F4F4F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.458 23.536L574.427 7.232C571.164 2.41 565.982 -0.000999378 560.8 3.10752e-07V23.536H585.458Z",
    fill: "#123787"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.8 0C555.62 0.002 550.442 2.411 547.18 7.23L536.145 23.536H560.8V0Z",
    fill: "#1d58d7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M584.355 81.4894C584.355 94.5404 573.775 105.12 560.723 105.12C547.673 105.12 537.093 94.5404 537.093 81.4894C537.093 68.4384 547.673 57.8584 560.723 57.8584C573.775 57.8584 584.355 68.4384 584.355 81.4894Z",
    fill: "#1d58d7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.717 81.4892C579.717 76.4972 577.782 71.9642 574.632 68.5742C574.642 68.9492 574.66 69.3222 574.66 69.7002C574.66 81.8032 569.599 92.7162 561.488 100.464C571.623 100.062 579.717 91.7232 579.717 81.4892Z",
    fill: "#1C6955"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.66 69.6998C574.66 69.3218 574.642 68.9488 574.632 68.5738C571.993 65.7338 568.507 63.6938 564.566 62.8838C564.604 63.4028 564.63 63.9248 564.63 64.4528C564.63 76.0198 555.254 85.3958 543.688 85.3958C543.159 85.3958 542.637 85.3688 542.119 85.3308C543.895 93.9788 551.55 100.483 560.723 100.483C560.98 100.483 561.234 100.474 561.488 100.464C569.599 92.7158 574.66 81.8028 574.66 69.6998Z",
    fill: "#289679"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.63 64.4531C564.63 63.9251 564.604 63.4031 564.566 62.8841C563.325 62.6291 562.04 62.4951 560.723 62.4951C550.234 62.4951 541.73 70.9991 541.73 81.4891C541.73 82.8051 541.864 84.0901 542.119 85.3311C542.637 85.3691 543.159 85.3961 543.688 85.3961C555.254 85.3961 564.63 76.0201 564.63 64.4531Z",
    fill: "#28BC97"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.119 107.909V145.555H606.793V111.938L599.119 107.909Z",
    fill: "#787878"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M634.975 133.608C634.975 129.38 632.63 125.5 628.886 123.535L606.793 111.938V145.554H628.658C632.147 145.554 634.975 142.726 634.975 139.238V133.608Z",
    fill: "#F8F8F8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.48 107.909V145.555H514.806V111.938L522.48 107.909Z",
    fill: "#787878"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.625 133.608C486.625 129.38 488.97 125.5 492.714 123.535L514.806 111.938V145.554H492.942C489.453 145.554 486.625 142.726 486.625 139.238V133.608Z",
    fill: "#F4F4F4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.421 159.007C584.596 159.007 562.82 159.007 562.82 159.007L563.368 128.195L593.6 158.427C592.862 158.683 592.246 159.007 588.421 159.007Z",
    fill: "#A2A2A2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.811 167.237C558.506 167.237 556.62 165.351 556.62 163.047V131.416C556.62 129.112 558.506 127.226 560.811 127.226C563.116 127.226 565.001 129.112 565.001 131.416V163.047C565.001 165.351 563.116 167.237 560.811 167.237Z",
    fill: "#787878"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.694 164.739C559.597 164.739 558.7 163.842 558.7 162.745V146.641C558.7 145.544 559.597 144.647 560.694 144.647C561.79 144.647 562.687 145.544 562.687 146.641V162.745C562.687 163.842 561.79 164.739 560.694 164.739Z",
    fill: "#FFFFFE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.912 94.2819C448.912 96.5749 447.054 98.4329 444.761 98.4329C442.468 98.4329 440.61 96.5749 440.61 94.2819C440.61 91.9899 442.468 90.1309 444.761 90.1309C447.054 90.1309 448.912 91.9899 448.912 94.2819Z",
    fill: "#1d58d7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.794 127.549C476.794 128.959 475.65 130.103 474.24 130.103C472.829 130.103 471.685 128.959 471.685 127.549C471.685 126.138 472.829 124.994 474.24 124.994C475.65 124.994 476.794 126.138 476.794 127.549Z",
    fill: "#FFA300"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.454 122.696H400.17C400.169 123.75 399.747 124.692 399.057 125.384C398.365 126.073 397.423 126.496 396.369 126.497C395.315 126.496 394.373 126.073 393.681 125.384C392.992 124.692 392.569 123.75 392.568 122.696C392.569 121.642 392.992 120.7 393.681 120.008C394.373 119.318 395.315 118.896 396.369 118.895C397.423 118.896 398.365 119.318 399.057 120.008C399.747 120.7 400.169 121.642 400.17 122.696H402.739C402.738 119.178 399.887 116.327 396.369 116.326C392.85 116.327 390 119.178 390 122.696C390 126.214 392.851 129.065 396.369 129.065C399.887 129.065 402.738 126.215 402.739 122.696H401.454Z",
    fill: "#FFA300"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.315 92.7422C684.315 94.4692 682.916 95.8672 681.191 95.8672C679.465 95.8672 678.066 94.4692 678.066 92.7422C678.066 91.0172 679.465 89.6182 681.191 89.6182C682.916 89.6182 684.315 91.0172 684.315 92.7422Z",
    fill: "#5173fb"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M717.591 136.412C717.591 138.881 715.59 140.883 713.121 140.883C710.652 140.883 708.651 138.881 708.651 136.412C708.651 133.944 710.652 131.942 713.121 131.942C715.59 131.942 717.591 133.944 717.591 136.412Z",
    fill: "#FFA300"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.165 115.182C648.165 116.288 647.269 117.185 646.162 117.185C645.056 117.185 644.159 116.288 644.159 115.182C644.159 114.075 645.056 113.179 646.162 113.179C647.269 113.179 648.165 114.075 648.165 115.182Z",
    fill: "#FFA300"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.179 210.52C619.179 212.637 617.463 214.352 615.347 214.352C613.231 214.352 611.516 212.637 611.516 210.52C611.516 208.404 613.231 206.688 615.347 206.688C617.463 206.688 619.179 208.404 619.179 210.52Z",
    fill: "#1d58d7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.15 245.027C527.15 246.968 525.578 248.54 523.638 248.54C521.698 248.54 520.126 246.968 520.126 245.027C520.126 243.088 521.698 241.515 523.638 241.515C525.578 241.515 527.15 243.088 527.15 245.027Z",
    fill: "#1d58d7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.792 158.122H432.489V154.82C432.489 153.702 431.575 152.788 430.457 152.788C429.339 152.788 428.425 153.702 428.425 154.82V158.122H425.122C424.005 158.122 423.09 159.037 423.09 160.155C423.09 161.272 424.005 162.187 425.122 162.187H428.425V165.489C428.425 166.607 429.339 167.521 430.457 167.521C431.575 167.521 432.489 166.607 432.489 165.489V162.187H435.792C436.909 162.187 437.824 161.272 437.824 160.155C437.824 159.037 436.909 158.122 435.792 158.122Z",
    fill: "#1d58d7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.528 171.448H671.642V169.561C671.642 168.923 671.119 168.401 670.481 168.401C669.843 168.401 669.321 168.923 669.321 169.561V171.448H667.434C666.796 171.448 666.274 171.97 666.274 172.608C666.274 173.247 666.796 173.769 667.434 173.769H669.321V175.655C669.321 176.294 669.843 176.816 670.481 176.816C671.119 176.816 671.642 176.294 671.642 175.655V173.769H673.528C674.166 173.769 674.689 173.247 674.689 172.608C674.689 171.97 674.166 171.448 673.528 171.448Z",
    fill: "#1d58d7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.08 179.336C496.08 180.584 495.069 181.595 493.821 181.595C492.574 181.595 491.562 180.584 491.562 179.336C491.562 178.089 492.574 177.077 493.821 177.077C495.069 177.077 496.08 178.089 496.08 179.336Z",
    fill: "#FFFFFE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.639 226.371C488.639 227.471 487.747 228.364 486.646 228.364C485.546 228.364 484.653 227.471 484.653 226.371C484.653 225.27 485.546 224.378 486.646 224.378C487.747 224.378 488.639 225.27 488.639 226.371Z",
    fill: "#FFFFFE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M713.321 100.452H712.036C712.034 101.549 711.146 102.438 710.049 102.44C708.952 102.438 708.064 101.549 708.062 100.452C708.064 99.3565 708.952 98.4685 710.049 98.4665C711.146 98.4685 712.034 99.3565 712.036 100.452H714.605C714.604 97.9365 712.565 95.8985 710.049 95.8975C707.533 95.8985 705.494 97.9365 705.493 100.452C705.494 102.969 707.533 105.007 710.049 105.008C712.566 105.007 714.604 102.969 714.605 100.452H713.321Z",
    fill: "#1d58d7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.606a69170805508b74b6384063aff73f.svg";
export { ForwardRef as ReactComponent };